import {
  createEntityAdapter,
  createSlice,
  PayloadAction
} from '@reduxjs/toolkit'
import { RawUserData } from './types'

export const usersAdapter = createEntityAdapter<RawUserData>()

export const initialUsersState = usersAdapter.getInitialState({
  selectedId: null as string | null
})

export const usersSlice = createSlice({
  name: 'users',
  initialState: initialUsersState,
  reducers: {
    upsertOne: usersAdapter.upsertOne,
    upsertMany: usersAdapter.upsertMany,
    removeOne: usersAdapter.removeOne,
    removeAll: usersAdapter.removeAll,
    setSelectedUserId: (state, action: PayloadAction<string | null>) => {
      state.selectedId = action.payload
    }
  }
})

export const reducer = usersSlice.reducer

export const {
  upsertOne: upsertOneUser,
  upsertMany: upsertManyUsers,
  removeOne: removeOneUser,
  removeAll: removeAllUsers,
  setSelectedUserId
} = usersSlice.actions
